/**
 * Basic query params class to be used with RequestParams
 * in constructing request query strings
 */
export class QueryParams {
  params: { [key: string]: string | number } = {};
};